import API from "../../api/apiAdmin";

export const AdminOrderServices = {
    /**
     * Fetch paginated orders with optional status filter.
     * @param {number} page 
     * @param {number} per_page 
     * @param {string} status 
     */
    getOrders: async (page = 1, per_page = 50, status = '') => {
        try {
            const endpoint = `/admin/orders/?page=${page}&per_page=${per_page}${status ? `&status=${status}` : ''}`;
            const response = await API.get(endpoint);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Fetch order details by order reference ID.
     * @param {string} orderId 
     */
    getOrderDetails: async (orderId) => {
        try {
            const response = await API.get(`/admin/orders/${orderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Update an individual Order Item status.
     * @param {string} itemId 
     * @param {string} status - processing | completed | shipped
     */
    updateOrderItemStatus: async (itemId, status) => {
        try {
            const response = await API.put(`/admin/orders/items/${itemId}/status`, { status });
            return response.data;
        } catch (error) {
            throw error;
        }
    },


};
